import React from 'react';
import ReactDOM from 'react-dom/client';
import { App } from 'src/app/App.tsx';
import { ColorModeScript } from '@chakra-ui/react';
import { Settings } from 'luxon';

Settings.defaultLocale = 'pt-BR';

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
	<React.StrictMode>
		<ColorModeScript />
		<App />
	</React.StrictMode>,
);
